import { chat, goBack,  search } from "assets/icons";
import styled from "@emotion/styled";
import { Card, Col,  Row, Tabs, Typography } from "antd";
import React, { FC } from "react";
import { useNavigate } from "react-router-dom";
import AgentCard from "./AgentCard";

interface OrderAgentProps {
  id: string;
}

const items = [
  {
    label: `คำสั่งซื้อ(4)`,
    key: "1",
    children: <></>,
  },
  {
    label: `รอตัวแทนมารับ(0)`,
    key: "2",
    children: <></>,
  },
  {
    label: `เสร็จสิ้น`,
    key: "3",
    children: <></>,
  },
  {
    label: `ยกเลิก`,
    key: "4",
    children: <></>,
  },
  {
    label: `คืนเงิน/สินค้า(0)`,
    key: "5",
    children: <></>,
  },
];

const OrderAgent: FC<OrderAgentProps> = () => {
  const navigate = useNavigate();
  return (
    <>
      <Row className="rowgap-vbox" gutter={[24, 0]}>
        <Col span={24}>
          <Card bordered={false} className="criclebox h-full tabs-mobile">
            <ColumnWrapper>
              <HeaderTabs>
                <IconWrapper
                  onClick={() => {
                    navigate("/dashboard");
                  }}
                >
                  <SpanIcon>{goBack}</SpanIcon>
                </IconWrapper>
                <Typography.Title level={5}>จัดการคำสั่งซื้อ</Typography.Title>
                <RightIconWrapper>
                  <IconWrapper>
                    <SpanIcon>{search}</SpanIcon>
                  </IconWrapper>
                  <IconWrapper>
                    <SpanIcon>{chat}</SpanIcon>
                  </IconWrapper>
                </RightIconWrapper>
              </HeaderTabs>
              <AgentsCardWrapper>
                <AgentCard />
              </AgentsCardWrapper>
            </ColumnWrapper>
            <WrapperAll>
              <Tabs
                defaultActiveKey="1"
                style={{ height: "100%" }}
                items={items}
                key="key"
              />
            </WrapperAll>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default OrderAgent;

const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-direction: row;
  border-bottom: 1px solid #efefef;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;

const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const AgentsCardWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 5px;
`;
